<template>
    <div class="card">
        <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <div class="font-weight-bold">Биллинг</div>
                <router-link :to="{ name: 'recharge' }" tag="button" class="btn btn-primary">Пополнить счет</router-link>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Сумма</th>
                        <th>Дата</th>
                        <th class="w-75 d-none d-md-table-cell">Комментарий</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="tx in transactions" :key="tx.id">
                        <td class="text-nowrap">
                            <strong :class="[ tx.type === 1 ? 'text-success' : 'text-danger' ]">{{ tx.amount | money }} {{ currency | currencySymbol }}</strong>
                        </td>
                        <td class="text-nowrap">{{ tx.created_at | date }}</td>
                        <td class="d-none d-md-table-cell" style="white-space: pre-wrap">{{ tx.comment || '–' }}</td>
                    </tr>
                </tbody>

                <tfoot v-if="transactions.length === 0" class="no-one">
                    <tr>
                        <td colspan="4">История начислений и списаний пуста.</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        transactions: {
            type: Array,
            default: _ => []
        },

        currency: {
            type: Number,
            default: null
        }
    }
}
</script>
